import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5f3aac8e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=5f3aac8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3aac8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3aac8e')) {
      api.createRecord('5f3aac8e', component.options)
    } else {
      api.reload('5f3aac8e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5f3aac8e&scoped=true&", function () {
      api.rerender('5f3aac8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/Index.vue"
export default component.exports